import { useState } from 'react'
import { Alert, Button, Card, Form, Spinner } from 'react-bootstrap'
import { IUser } from '../../models/user';
import { useMutation } from 'react-query';
import { useAuth } from '../../context/auth';

type Props = {
    user: IUser
}

function BasicSettings({user} : Props) {
    const [firstName, setFirstName] = useState(user.firstName);
    const [lastName, setLastName] = useState(user.lastName);
    const [error, setError] = useState("");
    const [edit, setEdit] = useState(false);

    const {updateUser} = useAuth();
    const { mutateAsync: updateUserFn, isLoading} = useMutation( updateUser,
        {
            onSuccess: () => {},
            onError: (error) => {
                setError("Unexpected error. Please try again or contact admin.");
            },
        }
    );

    const handleSubmit = async (e: { preventDefault: () => void; }) => {
        e.preventDefault();
        if(!firstName || !lastName) {
            setError("Please fill in all required fields");
            return;
        }
        if(user.firstName === firstName && user.lastName === lastName) {
            return;
        }
        
        updateUserFn({
            firstName,
            lastName,
        });
    }

    return (
        <Card className="mb-4 bg-dark text-white border-secondary">
            <Card.Body>
                <Button 
                    variant={edit ? "outline-secondary" : "outline-primary"}
                    onClick={e => setEdit(!edit)}
                    style={{position:'absolute', top:'1em',right:'1em'}}>
                    {edit ? "Cancel" : "Edit"}
                </Button>
                <Card.Title className="text-white">General</Card.Title>
                <Form onSubmit={handleSubmit}>
                    <Form.Group controlId="firstname" className="mb-3">
                        <Form.Label className="text-white">First Name*</Form.Label>
                        <Form.Control 
                            type="text" 
                            value={firstName}
                            disabled={!edit}
                            onChange={e => setFirstName(e.target.value)}
                            className={`text-white border-secondary ${!edit ? 'bg-secondary bg-opacity-25' : 'bg-dark'}`}
                            style={{
                                backgroundColor: !edit ? 'rgba(108, 117, 125, 0.25)' : '#212529',
                                color: !edit ? '#adb5bd' : '#ffffff'
                            }}
                            required/>
                    </Form.Group>
                    <Form.Group controlId="lastname" className="mb-3">
                        <Form.Label className="text-white">Last Name*</Form.Label>
                        <Form.Control 
                            type="text" 
                            value={lastName} 
                            disabled={!edit}
                            onChange={e => setLastName(e.target.value)}
                            className={`text-white border-secondary ${!edit ? 'bg-secondary bg-opacity-25' : 'bg-dark'}`}
                            style={{
                                backgroundColor: !edit ? 'rgba(108, 117, 125, 0.25)' : '#212529',
                                color: !edit ? '#adb5bd' : '#ffffff'
                            }}
                            required/>
                    </Form.Group>
                    {error && (
                        <Alert variant="danger" className="mt-3 bg-danger bg-opacity-25 text-light border-danger">
                            {error}
                        </Alert>
                    )}
                    <Button 
                        type="submit" 
                        variant='primary'
                        disabled={user.firstName === firstName && user.lastName === lastName}>
                        {isLoading && <Spinner/>} Update 
                    </Button>
                </Form>
            </Card.Body>
        </Card>
    )
}

export default BasicSettings